import React, {
    memo, useState, useEffect,
} from 'react';
import { Link, useLocation } from 'react-router-dom';
import { List, X } from '@phosphor-icons/react';
import { serialize } from 'cookie';
import { useSelector } from 'react-redux';
import ProfileIcon from '../profile/containers/ProfileIconContainer';
import Menu from './components/Menu';
import MenuProfileMobile from './components/MenuProfileMenu';
import SearchButton from '../search/containers/SearchButtonContainer';
// import { social } from './data/menu';
import NewsCategoryListContainer from './containers/NavbarContainerNews';
import { showError } from '../../common/A1Alert/A1Alert';


const areEqual = (prevProps, nextProps) => prevProps.currentPath === nextProps.currentPath;

const MenuBar = memo(() => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [hasHydrated, setHasHydrated] = useState(false);

    const isLoggedIn = useSelector((state) => !!state.profile.jwt);
    const user = useSelector((state) => state.profile.user);
    const fetchingProfile = useSelector((state) => state.profile.fetchingProfile);

    useEffect(() => {
        setHasHydrated(true);
    }, []);

    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'auto'
        }
    }, [isMenuOpen]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 768) {
                setIsMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [isMenuOpen]);

    const handleLogout = () => {
        try {
            document.cookie = serialize('auth_jwt', '', {
                path: '/',
                sameSite: 'strict',
                expires: new Date('Thu, 01 Jan 1970 00:00:01 GMT'),
            });

            window.location.href = '/';
        } catch (error) {
            showError(error);
        }
    };

    return (
        <nav className="header tw-container tw-m-auto md:tw-w-full tw-bg-white tw-text-slate-900 tw-px-5">
            <div className="tw-container tw-m-auto">
                <div className="header-logo tw-grid tw-grid-cols-4 justify-center">
                    <div className="header-social">
                        <a href="https://www.facebook.com/Antena1.BR" target="_blank" rel="noreferrer" className="header-social-link" role="button" aria-label="Ir para o Facebook da Antena 1">
                            <svg width="20" height="20" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 8.07886C15 3.92848 11.64 0.560059 7.5 0.560059C3.36 0.560059 0 3.92848 0 8.07886C0 11.7179 2.58 14.748 6 15.4472V10.3345H4.5V8.07886H6V6.19916C6 4.74803 7.1775 3.56757 8.625 3.56757H10.5V5.82322H9C8.5875 5.82322 8.25 6.16156 8.25 6.5751V8.07886H10.5V10.3345H8.25V15.5601C12.0375 15.1841 15 11.9811 15 8.07886Z" fill="#D0D5DD" />
                            </svg>
                        </a>
                        <a href="https://twitter.com/Antena_1" target="_blank" rel="noreferrer" className="header-social-link" role="button" aria-label="Ir para o Twitter da Antena 1">
                            <svg width="22" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.24952 0.560059H0L6.19444 8.82131L0.337469 15.5601H2.32479L7.11535 10.0483L11.249 15.5601H16.4985L10.0431 6.95156L15.5986 0.560059H13.6112L9.12215 5.72456L5.24952 0.560059ZM11.9989 14.0601L2.99973 2.06006H4.49959L13.4988 14.0601H11.9989Z" fill="#D0D5DD" />
                            </svg>
                        </a>
                        <a href="https://www.instagram.com/antena1/" target="_blank" rel="noreferrer" className="header-social-link" role="button" aria-label="Ir para o Instagram da Antena 1">
                            <svg width="18" height="18" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.27115 0.560981C8.8184 0.558881 9.36574 0.564382 9.91283 0.577481L10.0583 0.582731C10.2263 0.58873 10.3921 0.59623 10.5923 0.60523C11.3903 0.642729 11.9348 0.768725 12.4125 0.953968C12.9075 1.14446 13.3245 1.40246 13.7415 1.81944C14.1227 2.19413 14.4178 2.64737 14.6062 3.14764C14.7914 3.62538 14.9174 4.1706 14.9549 4.96858C14.9639 5.16807 14.9714 5.33456 14.9774 5.50256L14.9819 5.64805C14.9953 6.19493 15.001 6.74196 14.9992 7.289L14.9999 7.84848V8.83095C15.0017 9.37821 14.996 9.92555 14.9827 10.4726L14.9782 10.6181C14.9722 10.7861 14.9647 10.9519 14.9557 11.1522C14.9182 11.9501 14.7907 12.4946 14.6062 12.9723C14.4184 13.4731 14.1232 13.9267 13.7415 14.3013C13.3665 14.6825 12.913 14.9775 12.4125 15.166C11.9348 15.3512 11.3903 15.4772 10.5923 15.5147C10.3921 15.5237 10.2263 15.5312 10.0583 15.5372L9.91283 15.5417C9.36574 15.5551 8.8184 15.5608 8.27115 15.559L7.71166 15.5597H6.72995C6.18266 15.5616 5.63539 15.5558 5.08826 15.5425L4.94277 15.538C4.76473 15.5315 4.58673 15.524 4.40878 15.5155C3.61081 15.478 3.06633 15.3505 2.58784 15.166C2.08738 14.978 1.63405 14.6829 1.25964 14.3013C0.87794 13.9264 0.582581 13.4729 0.394169 12.9723C0.208925 12.4946 0.0829298 11.9501 0.0454312 11.1522C0.0370786 10.9741 0.0295788 10.7961 0.022932 10.6181L0.0191822 10.4726C0.00535532 9.92555 -0.000895131 9.37821 0.000432736 8.83095V7.289C-0.00166042 6.74197 0.00383998 6.19494 0.0169322 5.64805L0.022182 5.50256C0.0281818 5.33456 0.0356815 5.16807 0.0446812 4.96858C0.08218 4.16986 0.208175 3.62613 0.393419 3.14764C0.581942 2.64713 0.877873 2.19401 1.26039 1.82019C1.63454 1.43826 2.08758 1.14264 2.58784 0.953968C3.06633 0.768725 3.61006 0.642729 4.40878 0.60523L4.94277 0.582731L5.08826 0.578981C5.63513 0.565161 6.18216 0.55891 6.7292 0.560231L8.27115 0.560981ZM7.50018 4.31085C7.00332 4.30382 6.51003 4.39561 6.04896 4.58089C5.58788 4.76617 5.16824 5.04123 4.8144 5.39011C4.46056 5.73898 4.17959 6.15469 3.98781 6.61309C3.79603 7.0715 3.69727 7.56344 3.69727 8.06035C3.69727 8.55725 3.79603 9.0492 3.98781 9.50762C4.17959 9.96597 4.46056 10.3817 4.8144 10.7306C5.16824 11.0795 5.58788 11.3545 6.04896 11.5398C6.51003 11.7251 7.00332 11.8168 7.50018 11.8098C8.49473 11.8098 9.44849 11.4147 10.1518 10.7116C10.8549 10.0083 11.25 9.05453 11.25 8.05998C11.25 7.06544 10.8549 6.11165 10.1518 5.40841C9.44849 4.70518 8.49473 4.31085 7.50018 4.31085ZM7.50018 5.8108C7.79905 5.8053 8.09602 5.8594 8.37372 5.96995C8.65148 6.0805 8.9044 6.2453 9.11774 6.45468C9.33099 6.66408 9.50049 6.91389 9.61616 7.18951C9.73191 7.46513 9.7915 7.76105 9.79158 8.05997C9.79158 8.35889 9.73208 8.65482 9.61649 8.93045C9.50091 9.20612 9.33149 9.45604 9.11824 9.66546C8.90498 9.87496 8.65214 10.0398 8.37447 10.1505C8.09675 10.2611 7.7998 10.3153 7.50093 10.3099C6.90421 10.3099 6.33193 10.0729 5.90999 9.65088C5.48805 9.22895 5.251 8.65669 5.251 8.05998C5.251 7.46326 5.48805 6.89098 5.90999 6.46903C6.33193 6.04709 6.90421 5.81005 7.50093 5.81005L7.50018 5.8108ZM11.4375 3.18589C11.1956 3.19558 10.9668 3.2985 10.799 3.47311C10.6313 3.64772 10.5376 3.88046 10.5376 4.12261C10.5376 4.36475 10.6313 4.5975 10.799 4.7721C10.9668 4.94672 11.1956 5.04964 11.4375 5.05933C11.6862 5.05933 11.9246 4.96056 12.1005 4.78475C12.2762 4.60893 12.375 4.37049 12.375 4.12186C12.375 3.87322 12.2762 3.63478 12.1005 3.45897C11.9246 3.28316 11.6862 3.18439 11.4375 3.18439V3.18589Z" fill="#D0D5DD" />
                            </svg>
                        </a>
                        <a href="https://www.linkedin.com/company/radioantena1/" target="_blank" rel="noreferrer" className="header-social-link" role="button" aria-label="Ir para o Linkedin da Antena 1">
                            <svg width="18" height="18" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.3336 0.560059C13.7756 0.560059 14.1995 0.735654 14.5121 1.04821C14.8247 1.36077 15.0002 1.7847 15.0002 2.22673V13.8934C15.0002 14.3354 14.8247 14.7593 14.5121 15.0719C14.1995 15.3845 13.7756 15.5601 13.3336 15.5601H1.66691C1.22489 15.5601 0.80096 15.3845 0.488399 15.0719C0.175839 14.7593 0.000244141 14.3354 0.000244141 13.8934V2.22673C0.000244141 1.7847 0.175839 1.36077 0.488399 1.04821C0.80096 0.735654 1.22489 0.560059 1.66691 0.560059H13.3336ZM12.9169 13.4767V9.06006C12.9169 8.33955 12.6307 7.64856 12.1212 7.13908C11.6117 6.62961 10.9207 6.34339 10.2002 6.34339C9.49191 6.34339 8.66691 6.77672 8.26691 7.42672V6.50173H5.94191V13.4767H8.26691V9.36839C8.26691 8.72672 8.78358 8.20173 9.42524 8.20173C9.73466 8.20173 10.0314 8.32464 10.2502 8.54343C10.469 8.76223 10.5919 9.05898 10.5919 9.36839V13.4767H12.9169ZM3.23358 5.19339C3.60488 5.19339 3.96098 5.04589 4.22353 4.78334C4.48608 4.52079 4.63358 4.16469 4.63358 3.79339C4.63358 3.01839 4.00858 2.38506 3.23358 2.38506C2.86006 2.38506 2.50185 2.53343 2.23774 2.79755C1.97362 3.06167 1.82524 3.41988 1.82524 3.79339C1.82524 4.56839 2.45858 5.19339 3.23358 5.19339ZM4.39191 13.4767V6.50173H2.08358V13.4767H4.39191Z" fill="#D0D5DD" />
                            </svg>
                        </a>
                        <a href="http://www.youtube.com/Antena1Brasil" target="_blank" rel="noreferrer" className="header-social-link" role="button" aria-label="Ir para o Youtube da Antena 1">
                            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_3670_9057)">
                                    <path d="M18.6028 2.45737C18.3842 1.63466 17.7408 0.986355 16.9229 0.766296C15.4418 0.367371 9.50024 0.367371 9.50024 0.367371C9.50024 0.367371 3.55866 0.367371 2.07688 0.766296C1.25974 0.986355 0.61626 1.63391 0.397686 2.45737C0.000244141 3.9488 0.000244141 7.06005 0.000244141 7.06005C0.000244141 7.06005 0.000244141 10.1713 0.397686 11.6627C0.61626 12.4854 1.25974 13.1337 2.07763 13.3538C3.55866 13.7527 9.50024 13.7527 9.50024 13.7527C9.50024 13.7527 15.4418 13.7527 16.9236 13.3538C17.7408 13.1337 18.3842 12.4862 18.6035 11.6627C19.0002 10.1713 19.0002 7.06005 19.0002 7.06005C19.0002 7.06005 19.0002 3.9488 18.6028 2.45737ZM7.55757 9.88555V4.23454L12.5228 7.06005L7.55757 9.88555Z" fill="#D0D5DD" />
                                </g>
                                <defs>
                                    <clipPath id="clip0_3670_9057">
                                        <rect width="19" height="13.3854" fill="white" transform="translate(0.000244141 0.367371)" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </a>
                    </div>

                    <div className="header-logo-img tw-col-span-4 md:tw-col-span-2">
                        <Link to="/" title="Antena 1 - A rádio online mais ouvida do Brasil">
                            <img src="https://a1media.antena1.com.br/image/misc/logo/a1-logo.svg" alt="Antena 1 - A rádio online mais ouvida do Brasil" title="Antena 1 - A rádio online mais ouvida do Brasil" />
                        </Link>
                    </div>

                    <div className="header-login">
                        <div className="header-busca">
                            <SearchButton currentPath={location.pathname} />
                        </div>
                        <span className="tw-text-gray-500 tw-mx-1 lg:tw-mx-3">|</span>
                        <div className="header-auth">
                            <ProfileIcon logout={handleLogout} />
                        </div>
                    </div>

                    <div className="header-login-mobile">
                        <SearchButton currentPath={location.pathname} />
                        {/* <ProfileIcon /> */}
                    </div>

                    {/* <div className="md:tw-flex tw-hidden tw-gap-4">
                        {social.map(({ title, to, Icon }) => (
                            <a
                                key={title}
                                href={to}
                                target="_blank"
                                rel="noopener noreferrer"
                                title={title}
                                className="tw-cursor-pointer tw-hover:text-gray-400 tw-transition tw-transform tw-duration-300 hover:tw-translate-y-[-2px]"
                            >
                                <Icon size={22} weight="fill" color="black" />
                            </a>
                        ))}
                    </div> */}

                    {/* <div className="tw-text-xl tw-cursor-pointer tw-z-50 tw-font-bold header-logo-img">
                        <Link to="/" title="logo">
                            <img src="https://a1media.antena1.com.br/image/misc/logo/new-logo.png" alt="Antena1 - A número 1 em música!" title="Antena1 - A número 1 em música!" className="tw-h-full md:tw-w-full tw-w-36 tw-object-contain" width={170} />
                        </Link>
                    </div> */}

                    {/* <div className="md:tw-flex tw-hidden tw-items-center tw-gap-4">
                        <div className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-hover:text-gray-400">
                            <SearchButton currentPath={location.pathname} />
                        </div>
                        <span className="tw-text-gray-500">|</span>
                        <div className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer tw-hover:text-gray-400">
                            <ProfileIcon />
                        </div>
                    </div> */}

                    <div className="md:tw-hidden tw-z-100 tw-flex tw-items-center header-menu-mobile">
                        <button
                            className="tw-text-black tw-z-50 tw-md:hidden tw-text-2xl"
                            type="button"
                            aria-label={isMenuOpen ? 'Fechar menu' : 'Abrir menu'}
                            aria-expanded={isMenuOpen}
                            aria-controls="conditional-menu"
                            onClick={() => {
                                setIsMenuOpen(!isMenuOpen);

                                !isMenuOpen ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto'
                            }}
                        >
                            {isMenuOpen ? <X size={28} id="header-closed-menu" /> : <List size={28} id="header-opened-menu" />}
                        </button>
                    </div>
                </div>

                <div id="menu" className="md:tw-flex tw-hidden tw-items-center tw-justify-between header-menu">
                    <Menu />
                </div>

                <div
                    className={`header-menu-content md:tw-hidden tw-flex tw-flex-col tw-transition-all tw-duration-300 ${isMenuOpen ? 'tw-block' : 'tw-hidden'} tw-max-h-[100dvh] tw-overflow-y-auto tw-pb-8`}
                    id="conditional-menu"
                >
                    <div className=" tw-border-t tw-border-b tw-border-black tw-my-4 tw-pb-4 tw-pt-4">
                        {hasHydrated && isLoggedIn ? (
                            <MenuProfileMobile
                                user={user}
                                fetchingProfile={fetchingProfile}
                                logout={handleLogout}
                                setIsMenuOpen={setIsMenuOpen}
                            />
                        ) : (
                            <ProfileIcon logout={handleLogout} />
                        )}
                    </div>

                    <Menu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />

                    <NewsCategoryListContainer isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
                </div>

                <div className="md:tw-flex tw-items-start tw-justify-start tw-hidden header-category">
                    <NewsCategoryListContainer />
                </div>
            </div>
        </nav>
    );
}, areEqual);


export default MenuBar;
